<template>
  <div>
    <viewcard--c title="Demandas" :btnew="btnew">
      <b-row class="mb-1 d-flex justify-content-end">
        <b-col>
          <b-button
            v-if="buttonProducts"
            variant="info"
            @click="goRoute('audiovisual-demands-products')"
            id="button-product"
          >
            <feather-icon icon="ServerIcon" />
            <b-tooltip
              triggers="hover"
              target="button-product"
              title="Produtos"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>

          <b-button
            v-if="buttonFormat"
            class="ml-1"
            variant="info"
            @click="goRoute('audiovisual-demands-format-type')"
            id="button-format"
          >
            <feather-icon icon="FilmIcon" />
            <b-tooltip
              triggers="hover"
              target="button-format"
              title="Formatos"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>

          <b-button
            v-if="buttonPeriods"
            class="ml-1"
            variant="info"
            @click="goRoute('audiovisual-demands-period-type')"
            id="button-periods"
          >
            <feather-icon icon="ClockIcon" />
            <b-tooltip
              triggers="hover"
              target="button-periods"
              title="Períodos"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>

          <b-button
            v-if="buttonTransmission"
            class="ml-1"
            variant="info"
            @click="goRoute('audiovisual-demands-transmission-type')"
            id="button-transmission"
          >
            <feather-icon icon="RadioIcon" />
            <b-tooltip
              triggers="hover"
              target="button-transmission"
              title="Tipo de Transmissão"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>

          <b-button
            v-if="buttonChecklist"
            class="ml-1"
            variant="info"
            @click="goRoute('audiovisual-demands-checklist')"
            id="button-checklist"
          >
            <feather-icon icon="ListIcon" />
            <b-tooltip
              triggers="hover"
              target="button-checklist"
              title="Checklist"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>

          <b-button
            v-if="buttonChecklist"
            class="ml-1"
            variant="info"
            @click="goRoute('audiovisual-demands-work-shift')"
            id="button-work-shift"
          >
            <feather-icon icon="SunsetIcon" />
            <b-tooltip
              triggers="hover"
              target="button-work-shift"
              title="Turno"
              :delay="{ show: 100, hide: 50 }"
            />
          </b-button>
        </b-col>
        <b-col md="5">
          <b-input-group>
            <b-form-input
              placeholder="Pesquise por Nome..."
              autocomplete="off"
              v-model="search"
              @keyup.enter="filter"
            />
            <b-input-group-append>
              <b-button variant="info" @click="filter">
                <feather-icon icon="SearchIcon" class="mr-50"/>
                <span>Pesquisar</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <view--c
        :permission="'permission.audiovisual.demands.period.view'"
        :busy="isloading"
      >
        <Table
          :fields="fields"
          :list="!isloading && list[currentePage] ? list[currentePage].itens : []"
          @orderBy="getRecordsOrderBy"
          @rowClick="onClickSelected"
          border="full"
          responsive
        />

        <b-pagination
          v-model="currentePage"
          @change="getLoadMore"
          :total-rows="rows"
          :per-page="size"
          v-if="rows > 1"
          first-number
          last-number
          align="center"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </view--c>
    </viewcard--c>
  </div>
</template>

<script>
import Table from "@/components/Table.vue";
import _jobTypeService from "@/services/audiovisual/job-type-service";
export default {
  components: {
    Table,
  },
  data() {
    return {
      btnew: {
        permission: "permission.audiovisual.demands.period.create",
        to: "/audio-visual/demands/job-type/0",
      },
      isloading: false,
      currentePage: 1,
      search: null,
      size: this.$utils.paginationSize(),
      rows: 1,
      fields: [
        { key: "id", label: "ID", orderBy: { type: "back" } },
        { key: "name", label: "Nome", orderBy: { type: "back" } },
      ],
      list: [
        {
          page: 0,
          itens: [],
        },
      ],
      orderByParams: {
        search: '',
        ascOrDes: true,
        orderByKey: ''
      },
      buttonChecklist: false,
      buttonTransmission: false,
      buttonPeriods: false,
      buttonFormat: false,
      buttonProducts: false,
      buttonWorkShift: false
    };
  },
  created() {
    this.buttonChecklist = this.$utils.isPermited(
      "permission.audiovisual.demands.checklist.view"
    );
    this.buttonTransmission = this.$utils.isPermited(
      "permission.audiovisual.demands.typetransmissao.view"
    );
    this.buttonPeriods = this.$utils.isPermited(
      "permission.audiovisual.demands.period.view"
    );
    this.buttonFormat = this.$utils.isPermited(
      "permission.audiovisual.demands.typeformats.view"
    );
    this.buttonProducts = this.$utils.isPermited(
      "permission.audiovisual.demands.products.view"
    );
    this.buttonWorkShift = this.$utils.isPermited(
      "permission.audiovisual.demands.workshift.view"
    );
    this.getRecords(this.currentePage);
  },
  methods: {
    getRecords(_page, isOrder = false) {
      this.isloading = true;
      _jobTypeService
        .show(_page, this.orderByParams)
        .then((res) => {
          if (res.content) {
            this.list.push({ page: _page, itens: res.content });
            if (res.content.length > 0) {
              if (isOrder) return;
              this.rows += res.content.length;
              this.currentePage = _page;
            }
          }
        })
        .catch((error) => this.$utils.toastError("Notificação", error))
        .finally(() => {
          this.orderList();
          this.isloading = false;
        });
    },
    getLoadMore(_page) {
      if (!this.list.some((s) => s.page === _page)) {
        this.getRecords(_page);
      }
    },
    getRecordsOrderBy(_params) {
      this.orderByParams.ascOrDes = _params.ascOrDes;
      this.orderByParams.orderByKey = _params.orderByKey;
      let oldList = this.list.map((m) => m);
      this.list = [{ page: 0, itens: [] }];
      oldList.forEach((l) => {
        if (l.page < 1) return;
        this.getRecords(l.page, true);
      });
    },
    orderList() {
      this.list.sort((a, b) => {
        if (a.page < b.page) return -1;
        if (a.page > b.page) return 1;
        return 0;
      });
    },
    filter() {
      this.currentePage = 1;
      this.rows = 1;
      this.list = [{ page: 0, itens: [] }];
      this.orderByParams.search = this.search;
      this.getRecords(this.currentePage);
    },
    onClickSelected(record, _) {
      this.$router.push({
        path: `/audio-visual/demands/job-type/${record.id}`,
      });
    },
    goRoute(_name) {
      this.$router.push({ name: _name });
    },
  },
};
</script>